/**
 * @generated SignedSource<<bcf73b3032f8f22ff644635bd166a69f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavigationTab_brand$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CartCard_brand" | "GorgiasCard_brand" | "MenuCard_brand" | "ShortcutsCard_brand" | "TabsCard2_brand" | "UniversalLinkCard_brand" | "WishlistCard_brand">;
  readonly " $fragmentType": "NavigationTab_brand";
};
export type NavigationTab_brand$key = {
  readonly " $data"?: NavigationTab_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationTab_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavigationTab_brand",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CartCard_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GorgiasCard_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MenuCard_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShortcutsCard_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TabsCard2_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WishlistCard_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UniversalLinkCard_brand"
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "a4090909eda17d974e700fe716776462";

export default node;
